import type { TeamMember, GroupMember } from '../util';

const toTeamMember = (user: any): TeamMember => ({
  id: user.id,
  firstName: user.firstName,
  lastName: user.lastName,
  location: user.location,
  address: user.address,
  email: user.email,
  role: user.role,
  avatarFilestackId: user.avatarFilestackId,
});

const toGroupMember = (user: any): GroupMember => ({
  id: user.id,
  firstName: user.firstName,
  lastName: user.lastName,
  location: user.location,
  address: user.address,
  email: user.email,
  role: user.role,
  avatarFilestackId: user.avatarFilestackId,
});

export { toTeamMember, toGroupMember };
